import { useEffect } from 'react'

interface UseChangeTabVisibilityProps {
    onTabHidden?: () => void
    onTabVisible?: () => void
}

const useChangeTabVisibility = ({ onTabHidden, onTabVisible }: UseChangeTabVisibilityProps) => {
    useEffect(() => {
        const handleVisibilityChange = () => {
            if (document.hidden) {
                onTabHidden?.()
            } else {
                onTabVisible?.()
            }
        }

        document.addEventListener('visibilitychange', handleVisibilityChange)

        return () => {
            document.removeEventListener('visibilitychange', handleVisibilityChange)
        }
    }, [onTabHidden, onTabVisible])
}

export default useChangeTabVisibility
